import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import MaterialTable from "material-table";
import { API_URL } from "../../../config";
import Top from "../Top";
import "../Products/product.css";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box, TextField, Typography } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import axios from "axios";
import SuccessPop from "../SuccessPop/SuccessPop";
import ErrorPop from "../ErrorrPop/ErrorPop";
import DetailPopUp from "../Products/DetailPopUp";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import EditFaq from "./EditFaq";
import DeleteFaq from "./DeleteFaq";

const useStyles = makeStyles((theme) => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
  bin1: {
    margin: "5px 0 !important",
    padding: "15px",
    width: "100%",
    border: "1px solid #7c13867d !important",
    borderRadius: "8px ",
    background: "transparent",
    color: "#fff",
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&:focus-Visible": {
      outline: "none !important",
      border: "none !important",
    },
    "&:hover": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      "&::before": {
        display: "none",
      },
      "&::after": {
        display: "none",
      },
    },

    "&:focus": {
      boxShadow: "none !important",
      border: "1px solid #7c13867d !important",
      borderRadius: "10px !important ",
    },
    "& input": {
      padding: "10px",
      fontSize: "15px",
      borderRadius: "10px",
      fontWeight: "500",
      "&::placeholder": {
        color: "#7C1386 !important",
        fontSize: "15px",
      },
    },
    "& textarea": {
      fontSize: "16px",
      color: "#7c13867d !important",
      padding: "10px !important",
      fontWeight: "500",
    },
  },
  btns: {
    textAlign: "center",
    margin: "10px 0",
    "& button": {
      fontSize: "15px",
      background: "#7C1386 !important",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: "#fff",
      padding: "10px 30px",
      transition: "0.3s all !important",

      "&.Mui-disabled": {
        cursor: "not-allowed !important",
        pointerEvents: "auto !important",
        color: "rgb(255 255 255 / 38%) !important",
        "&:hover": {
          opacity: "1",
          transform: "scale(1) !important",
        },
      },
    },
  },
  error: {
    color: "#f14668",
    fontSize: "14px !important",
    paddingTop: "3px",
    wordBreak: "break-all",
  },
}));

const Faq = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [changeExpirydateModal, setChangeExpirydateModal] = useState(false);
  const handleAdd = () => setChangeExpirydateModal(!changeExpirydateModal);
  const [openEdit, setOpenEdit] = useState(false);
  const handleEditOpen = () => setOpenEdit(true);
  const handleEditClose = () => setOpenEdit(false);
  const handleEditPop = () => setOpenEdit(!openEdit);
  const [openSuccess, setOpenSuccess] = useState(false);
  const handleSuccesssPop = () => setOpenSuccess(!openSuccess);
  const [openDelete, setOpenDelete] = useState(false);
  const handleDeletePop = () => setOpenDelete(!openDelete);
  const handleDeleteOpen = () => setOpenDelete(true);

  const [openError, setOpenError] = useState(false);
  const handleErrorPop = () => setOpenError(!openError);
  const [openDetail, setOpenDetail] = useState(false);
  const handleDetail = () => setOpenDetail(!openDetail);
  const [selectCategroy, setSelectCategroy] = useState("Select Category");
  const [categroyData, setCategroyData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [message, setMessage] = useState("");
  const handleMesssage = (value) => setMessage(value);
  const [deleteId, setDeleteId] = useState("");
  const [description, setDescription] = useState("");
  const [filterSelect, setFilterSelect] = useState("0");

  const [isDescription, setIsDescription] = useState(false);

   const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [convertedContent, setConvertedContent] = useState("");
  // console.log(convertedContent);
  

  const handleEditorChange = (state) => {
    setEditorState(state);
    const rawContentState = convertToRaw(state.getCurrentContent());
    const html = draftToHtml(rawContentState);
    setConvertedContent(html);
  };

  // console.log(editorState);
  // console.log(convertedContent);





  const validationSchema = yup.object({
    question: yup.string().required("Required").trim(),
  });
  const formik = useFormik({
    initialValues: {
      question: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      let data = {
        question:values.question,
        answer:convertedContent,
        category:selectCategroy,
        status:1,
      }

      try {
        const response = await axios.post(`${API_URL}/create/faq`, data);

        if (response.status === 201) {
          const resp = response.data;
          handleMesssage(resp.message);
          getFaq(0);
          handleAdd();
          handleSuccesssPop();
          resetForm();
          setSelectCategroy("");
        }
      } catch (error) {
        if (error.response.status === 400 || error.response.status === 404) {
          alert("code error")
          handleMesssage(error.response.data.message);
          handleErrorPop();
        } else {
          throw new Error("Network error");
        }
      }
    },
  });
  useEffect(() => {
    getAllCategroy();
    
  }, []);

  useEffect(() => {
    if(filterSelect){
      getFaq(filterSelect)
    }else{
      getFaq(0)

    }
  }, [filterSelect]);


  const getFaq = (filterSelect) => {
    let url = `${API_URL}/get/all/faq`
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        let _temp = [];
        resp.faqs.map((v, i) => {
          console.log(v.answer);
          
          filterSelect === v.category ?
          _temp.push({
            question:v.question,
            answer:<div dangerouslySetInnerHTML={{ __html: v.answer }} />,
            category:v?.category_name,
            action: (
              <p className="action-p">
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Edit"
                  placement="top"
                >
                  <i
                    className="fa fa-edit action-icon"
                    onClick={() => handleEdit(v.id)}
                  ></i>
                </Tooltip>
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Delete"
                  plac  ement="top"
                >
                  <i
                    className="fa fa-trash-o action-icon"
                    onClick={() => handleDelete(v.id)}
                  ></i>
                </Tooltip>

              </p>
            ),
          }):

          filterSelect == 0 && _temp.push({
            question:v.question,
            answer:<div dangerouslySetInnerHTML={{ __html: v.answer }} />,
            category:v?.category_name,
            action: (
              <p className="action-p">
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Edit"
                  placement="top"
                >
                  <i
                    className="fa fa-edit action-icon"
                    onClick={() => handleEdit(v.id)}
                  ></i>
                </Tooltip>
                <Tooltip
                  classes={{
                    tooltip: classes.customTooltip,
                  }}
                  title="Delete"
                  plac  ement="top"
                >
                  <i
                    className="fa fa-trash-o action-icon"
                    onClick={() => handleDelete(v.id)}
                  ></i>
                </Tooltip>

              </p>
            ),
          });

        });
        let revData = _temp.reverse();
        setData(revData);
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };

  const getAllCategroy = () => {
    fetch(API_URL + "/get/all/faqCategory", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        setCategroyData(resp.faqscategory);
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };


  const handleEdit = (id) => {
    handleEditOpen();
    getFaqByID(id);
  };

  const getFaqByID = (id) => {
    fetch(API_URL + `/get/faq/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        setUpdateData(resp.faq);
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };

  const handleDelete = (id) => {
    handleDeleteOpen();
    setDeleteId(id);
  };


  const deleteFaq = () => {
    fetch(API_URL + `/delete/faq/${deleteId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        getFaq(0);
        handleDeletePop();
        handleMesssage(data.message);
        handleSuccesssPop();
      })
      .catch((error) => {
        console.error("Error during DELETE request:", error);
      });
  };

  const handleAddFaq = () => {
    handleAdd();
  };

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const columns = [
    {
      title: "Questions",
      field: "question",
    },
    {
      title: "Categories",
      field: "category",
    },
    {
      title: "Answer",
      field: "answer",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center", // Align the header to the center
      },
    },
    {
      title: "Action",
      field: "action",
    },
  ];



  const handleSelect = (event) => {
    setSelectCategroy(event.target.value);
  };



  const handleFilterSelect = (e) => {
    setFilterSelect(e.target.value);
  };

const convertHtmlToText = (html) => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = html;
  return tempElement.textContent || tempElement.innerText || "";
};


  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="onlineaccess-wrp">
            <div className="onlineaccess-child1">
              <h3>FAQs</h3>
            </div>
            <div className="add-btn">
              <button onClick={handleAddFaq}>Add FAQ</button>
            </div>
          </div>

          <Box
            sx={{
              width: "20%",
              display: "flex",
              flexDirection: "column",
              padding: "0.5rem 0rem 1rem 0rem",
              gap: 1,
              "@media(max-width:600px)": { width: "100% !important" },
            }}
          >
            <Typography
              component={"label"}
              sx={{ fontWeight: "600", color: "#7C1386" }}
            >
              Filter by category
            </Typography>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              placeholder="Select Categroy"
              value={filterSelect}
              label="Categroy"
              onChange={(e) => handleFilterSelect(e)}
              sx={{
                border: "1px solid purple",
                "& .MuiSelect-select": {
                  padding: "10px !important",
                  border: "1px solid #7c13867d !important",
                },
              }}
            >
              <MenuItem value="0">All</MenuItem>
              {categroyData?.map((item, i) => (
                <MenuItem value={item?.id}>{item?.name}</MenuItem>
              ))}
            </Select>
          </Box>

          <div className="wrp-bankform">
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  options={{
                    search: true,
                    showTitle: false,
                    toolbar: true,
                    pageSize: 20,
                    //  pageSize: data?.length <= 5 ? 5 : data?.length > 5 && data?.length <= 10 ? 10 : data?.length > 10 && data?.length <= 20 ? 20 : data?.length > 20 && data?.length <= 30 ? 30 : data?.length > 30 && data?.length <= 40 ? 40 : data?.length > 40 && data?.length <= 50 ? 50 : data?.length > 50 && data?.length <= 100 ? 100 : 150,
                    pageSizeOptions: [5, 10, 20, 50, 100, 150, 200],
                  }}
                  columns={columns}
                  data={data}
                  title=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={changeExpirydateModal}
        toggle={handleAdd}
        className="connect-boxSupport"
        centered={true}
      >
        <ModalHeader toggle={handleAdd}>
          <span className="ml-1 roititle">Add FAQ</span>
        </ModalHeader>
        <ModalBody>
          <div className="changedate-box">
            <form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  "@media(max-width:600px)": {
                    flexDirection: "column",
                    // gap:'10px !important'
                  },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    "@media(max-width:600px)": { width: "100% !important" },
                  }}
                >
                  {/* row 1 left side  */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      "@media(max-width:600px)": {
                        flexDirection: "column",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        "@media(max-width:600px)": { width: "100% !important" },
                      }}
                    >
                      <Typography
                        component={"label"}
                        sx={{ fontWeight: "600", color: "#7C1386" }}
                      >
                        Question<sup>*</sup>
                      </Typography>
                      <TextField
                        autoComplete="off"
                        fullWidth
                        id="Question"
                        name="question"
                        type="text"
                        className={classes.bin1}
                        value={formik.values.question}
                        placeholder="Enter Question "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        variant="standard"
                      />
                      {formik.touched.question && formik.errors.question && (
                        <Typography variant="body1" className={classes.error}>
                          {formik.errors.question}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* row 2 leftside */}

                  {/* row 3 left side */}

                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      "@media(max-width:600px)": { width: "100% !important" },
                    }}
                  >
                    <Typography
                      component={"label"}
                      sx={{ fontWeight: "600", color: "#7C1386" }}
                    >
                      Category<sup>*</sup>
                    </Typography>
                    {console.log(categroyData, "selectCategroy response")}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      placeholder="Select Categroy"
                      value={selectCategroy}
                      label="category"
                      onChange={(e) => handleSelect(e)}
                      sx={{
                        border: "1px solid purple",
                        "& .MuiSelect-select": {
                          padding: "10px !important",
                          border: "1px solid #7c13867d !important",
                        },
                      }}
                    >
                    <MenuItem value={"Select Category"} >Select Category</MenuItem>
                    {categroyData?.map((item, i) => (
                <MenuItem value={item?.id} key={i}>{item?.name}</MenuItem>
              ))}
                    </Select>
                  </Box>

                  <Box
                    sx={{
                      width: "100%",
                      paddingTop: "0.6rem",
                      "@media(max-width:600px)": { width: "100% !important" },
                    }}
                  >
                    <Typography
                      component={"label"}
                      sx={{
                        fontWeight: "600",
                        color: "#7C1386",
                        paddingBottom: "0.38rem",
                      }}
                    >
                      Answer
                    </Typography>
                    <Box
                      sx={{
                        border: "1px solid purple",
                        borderRadius: "4px",
                        height: "300px",
                        // overflowY:"auto",
                        width: "100%",
                        "& .rdw-editor-main": {
                          padding: "0rem 0.5rem",
                          height:"182px",
                          overflowY:'auto',
                        },
                        "& a": {
                          color: "purple !important",
                        },
                        "& a:hover": {
                          color: "purple !important",
                        },
                      }}
                    >
                      <Editor
                        editorState={editorState}
                        onEditorStateChange={handleEditorChange}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                      />
                    </Box>
                    {isDescription && (
                      <Typography component={"p"}>Required</Typography>
                    )}
                  </Box>
                </Box>

                {/* unused code  */}
              </Box>

              <Box className={classes.btns}>
                <Button
                  type="submit"
                  disabled={!(formik.isValid && formik.dirty)}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </div>
        </ModalBody>
      </Modal>
      <EditFaq  
        handleEditPop={handleEditPop}
        openEdit={openEdit}
        updateData={updateData}
        categroyData={categroyData}
        getFaq={getFaq}
        handleMesssage={handleMesssage}
        handleSuccesssPop={handleSuccesssPop}
        handleErrorPop={handleErrorPop}
        handleEditOpen={handleEditOpen}
        handleEditClose={handleEditClose}
      />
      <SuccessPop
        handleSuccesssPop={handleSuccesssPop}
        openSuccess={openSuccess}
        message={message}
      />
      <ErrorPop
        handleErrorPop={handleErrorPop}
        openError={openError}
        message={message}
      />

      <DetailPopUp
        handleErrorPop={handleDetail}
        openError={openDetail}
        message={description}
      />
      <DeleteFaq
        handleSuccesssPop={handleDeletePop}
        openSuccess={openDelete}
        deleteFaq={deleteFaq}
      />
    </div>
  );
};

export default Faq;
